import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Pages.css";

const CorporateSustainability = () => {
  const navigate = useNavigate();

  return (
    <motion.div
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
      >
        <div className="page-container">
          <h1>S&S Healthcare Consulting: Empowering Healthcare Providers</h1>

          <p>
            S&S Healthcare Consulting was born from a simple yet powerful idea—to make a difference in the healthcare industry by supporting the people who dedicate their lives to caring for others. 
            Founded by two longtime friends with a shared passion for healthcare and technology, our company was built from the ground up with a singular mission: to empower healthcare providers and ensure that both practitioners and patients receive the best possible experience.
          </p>

          <h2>Why We Started</h2>
          <p>
            Having worked extensively in healthcare administration, medical billing, IT management, and financial operations, we saw firsthand the struggles that providers face daily.
            From navigating complex insurance systems to ensuring compliance with ever-changing regulations, healthcare professionals often find themselves overwhelmed by administrative burdens.
          </p>
          <p>
            The very people who dedicate their lives to patient care are frequently bogged down by paperwork, denied claims, and outdated systems that hinder efficiency. We knew there had to be a better way.
          </p>

          <h2>Our Mission</h2>
          <p>
            What started as countless late-night conversations and brainstorming sessions turned into a business dedicated to helping medical providers regain control over their time, finances, and operations.
          </p>
          <p>
            We understood that doctors, nurses, and healthcare administrators didn’t go into medicine to spend hours battling insurance companies or worrying about cybersecurity threats.
            They went into healthcare to heal, to serve, and to make a difference.
          </p>

          <h2>What We Do</h2>
          <p>
            At S&S Healthcare Consulting, we believe that healthcare should be patient-focused, not paperwork-focused. Our mission is not just about improving systems and processes—
            it’s about supporting the people behind them.
          </p>
          <p>
            We provide: <br />
            - Revenue Cycle Management: Optimized billing, coding, and claims processing. <br />
            - Compliance & Auditing: Ensuring providers meet Medicare, Medicaid, and insurance regulations. <br />
            - IT & Cybersecurity Solutions: Protecting sensitive patient data and securing healthcare systems. <br />
            - Workflow Optimization: Automating tasks to allow providers to focus on patient care.
          </p>

          <h2>Our Commitment to You</h2>
          <p>
            We know what it’s like to feel frustrated by inefficiencies, overwhelmed by regulations, and stretched too thin. 
            That’s why we stand by our partners every step of the way, ensuring that their time is spent where it matters most—caring for patients, growing their practices, and making a real impact in their communities.
          </p>

          <h2>Join Us in Transforming Healthcare</h2>
          <p>
            From two friends with a vision to a company that champions healthcare providers, S&S Healthcare Consulting is proud to be part of your journey.
            Together, we can create a future where healthcare is simpler, smarter, and more supportive for everyone involved.
          </p>
        </div>

    </motion.div>
  );
};

export default CorporateSustainability;
